/**
 * 描述： 资料目录维护
 * 录入人： 张磊
 */
import request from '../request.js'


/**
 * 描述： 资料目录维护 - 查询资料清单模板
 * 接口管理员： 李开明
 * 参数：{}
 */
export const selectTemplateFile = function (data) {
    return request({
        url: 'templateFile/selectTemplateFile',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}


/**
 * 描述： 资料目录维护 - 新增或编辑资料清单模板
 * 接口管理员： 李开明
 * 参数：{}
 */
export const saveOrUpdateTemplateFile = function (data) {
    return request({
        url: 'templateFile/saveOrUpdateTemplateFile',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 资料目录维护 - 删除资料清单模板
 * 接口管理员： 李开明
 * 参数：{}
 */
export const deleteTemplateFile = function (data) {
    return request({
        url: 'templateFile/deleteTemplateFile',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 资料目录维护 - 上移或下移资料清单模板
 * 接口管理员： 李开明
 * 参数：{}
 */
export const upOrDownTemplateFile = function (data) {
    return request({
        url: 'templateFile/upOrDownTemplateFile',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}